import styled from '../theme';

const StyleBase = styled.div`
  color: ${(props) => props.theme.color.body1};
  font-size: 14px;
  font-family: 'rather';

  @media (max-width: ${(props) => props.theme.mobileBreakpoint - 1}px) {
    font-size: 14px;
  }
`;

export default StyleBase;



// WEBPACK FOOTER //
// ./src/components/StyleBase.tsx